import React, { useState, useEffect, useCallback } from 'react'
import { api } from '../services/authService'
import toast from 'react-hot-toast'

// ---------------------------------------------------------------------------
// Integration definitions
// ---------------------------------------------------------------------------
const INTEGRATIONS_CONFIG = {
  brevo: {
    key: 'brevo',
    name: 'Brevo',
    description: 'Email marketing, automacao e campanhas',
    section: 'communication',
    color: '#0B996E',
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="#0B996E">
        <path d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v.01L12 13 2 4.01V4zm0 2.66V20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6.66l-9.47 8.52a1 1 0 0 1-1.06 0L2 6.66z" />
      </svg>
    ),
    fields: [
      { key: 'api_key', label: 'API Key', type: 'password', required: true, help: 'Encontre em Brevo > Configuracoes > Chaves de API' }
    ]
  },
  zapi: {
    key: 'zapi',
    name: 'Z-API',
    description: 'Integracao WhatsApp para envio de mensagens',
    section: 'communication',
    color: '#25D366',
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="#25D366">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
      </svg>
    ),
    fields: [
      { key: 'instance_id', label: 'Instance ID', type: 'text', required: true, help: 'ID da instancia Z-API' },
      { key: 'token', label: 'Token', type: 'password', required: true, help: 'Token de autenticacao da instancia' }
    ]
  },
  'meta-ads': {
    key: 'meta-ads',
    name: 'Meta Ads',
    description: 'Anuncios no Facebook e Instagram',
    section: 'ads',
    color: '#1877F2',
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="#1877F2">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
    fields: [
      { key: 'access_token', label: 'Access Token', type: 'password', required: true, help: 'Token de acesso longo do Facebook Marketing API' },
      { key: 'ad_account_id', label: 'Ad Account ID', type: 'text', required: true, help: 'ID da conta de anuncios (ex: act_123456789)' },
      { key: 'pixel_id', label: 'Pixel ID', type: 'text', required: false, help: 'ID do Meta Pixel para rastreamento de conversoes' },
      { key: 'app_id', label: 'App ID', type: 'text', required: false, help: 'ID do aplicativo Facebook' },
      { key: 'app_secret', label: 'App Secret', type: 'password', required: false, help: 'Chave secreta do aplicativo' }
    ]
  },
  'google-ads': {
    key: 'google-ads',
    name: 'Google Ads',
    description: 'Campanhas de pesquisa, display e YouTube',
    section: 'ads',
    color: '#4285F4',
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8">
        <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" fill="#4285F4" />
      </svg>
    ),
    fields: [
      { key: 'developer_token', label: 'Developer Token', type: 'password', required: true, help: 'Token de desenvolvedor do Google Ads API' },
      { key: 'client_id', label: 'Client ID', type: 'text', required: true, help: 'OAuth 2.0 Client ID do Google Cloud Console' },
      { key: 'client_secret', label: 'Client Secret', type: 'password', required: true, help: 'OAuth 2.0 Client Secret' },
      { key: 'refresh_token', label: 'Refresh Token', type: 'password', required: true, help: 'Token de atualizacao OAuth 2.0' },
      { key: 'customer_id', label: 'Customer ID', type: 'text', required: true, help: 'ID do cliente Google Ads (sem hifens, ex: 1234567890)' }
    ]
  },
  ga4: {
    key: 'ga4',
    name: 'Google Analytics 4',
    description: 'Metricas de acesso, conversoes e comportamento',
    section: 'analytics',
    color: '#E37400',
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="#E37400">
        <path d="M22.84 2.998v17.958a3.065 3.065 0 0 1-6.13 0V2.998a3.065 3.065 0 0 1 6.13 0zM13.054 9.235v11.72a3.065 3.065 0 0 1-6.13 0V9.236a3.065 3.065 0 0 1 6.13 0zM3.265 18.073a2.882 2.882 0 1 0 0 5.764 2.882 2.882 0 0 0 0-5.764z" />
      </svg>
    ),
    fields: [
      { key: 'api_secret', label: 'Measurement Protocol API Secret', type: 'password', required: true, help: 'Encontre em GA4 > Admin > Data Streams > Measurement Protocol' },
      { key: 'measurement_id', label: 'Measurement ID', type: 'text', required: true, help: 'ID de medicao (ex: G-XXXXXXXXXX)' }
    ]
  },
  'google-my-business': {
    key: 'google-my-business',
    name: 'Google Meu Negocio',
    description: 'Perfil comercial, avaliacoes e presenca local',
    section: 'presence',
    color: '#4285F4',
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8">
        <path d="M21.75 9h-1.94L18.12 3H5.88L4.19 9H2.25l-.42 2h.73L4 22h16l1.44-11h.73l-.42-2zM12 17.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" fill="#4285F4" />
        <circle cx="12" cy="14" r="2" fill="#34A853" />
      </svg>
    ),
    fields: [
      { key: 'client_id', label: 'Client ID', type: 'text', required: true, help: 'OAuth 2.0 Client ID do Google Cloud Console' },
      { key: 'client_secret', label: 'Client Secret', type: 'password', required: true, help: 'OAuth 2.0 Client Secret' },
      { key: 'refresh_token', label: 'Refresh Token', type: 'password', required: true, help: 'Token de atualizacao OAuth 2.0' },
      { key: 'account_id', label: 'Account ID', type: 'text', required: true, help: 'ID da conta Google Meu Negocio' },
      { key: 'location_id', label: 'Location ID', type: 'text', required: true, help: 'ID da localizacao do estabelecimento' }
    ]
  },
  'search-console': {
    key: 'search-console',
    name: 'Search Console',
    description: 'SEO, keywords, posicoes e trafego organico',
    section: 'seo',
    color: '#EA4335',
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="#EA4335">
        <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
      </svg>
    ),
    fields: [
      { key: 'client_id', label: 'Client ID', type: 'text', required: true, help: 'OAuth 2.0 Client ID do Google Cloud Console' },
      { key: 'client_secret', label: 'Client Secret', type: 'password', required: true, help: 'OAuth 2.0 Client Secret' },
      { key: 'refresh_token', label: 'Refresh Token', type: 'password', required: true, help: 'Token de atualizacao OAuth 2.0' },
      { key: 'site_url', label: 'Site URL', type: 'text', required: true, help: 'URL do site verificado (ex: https://viploclocadora.com.br)' }
    ]
  },
  'ga4-data': {
    key: 'ga4-data',
    name: 'GA4 Data API',
    description: 'Leitura de metricas: sessoes, usuarios, pageviews',
    section: 'analytics',
    color: '#F9AB00',
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="#F9AB00">
        <path d="M22.84 2.998v17.958a3.065 3.065 0 0 1-6.13 0V2.998a3.065 3.065 0 0 1 6.13 0zM13.054 9.235v11.72a3.065 3.065 0 0 1-6.13 0V9.236a3.065 3.065 0 0 1 6.13 0zM3.265 18.073a2.882 2.882 0 1 0 0 5.764 2.882 2.882 0 0 0 0-5.764z" />
      </svg>
    ),
    fields: [
      { key: 'client_id', label: 'Client ID', type: 'text', required: true, help: 'OAuth 2.0 Client ID do Google Cloud Console' },
      { key: 'client_secret', label: 'Client Secret', type: 'password', required: true, help: 'OAuth 2.0 Client Secret' },
      { key: 'refresh_token', label: 'Refresh Token', type: 'password', required: true, help: 'Token de atualizacao OAuth 2.0' },
      { key: 'property_id', label: 'Property ID', type: 'text', required: true, help: 'ID da propriedade GA4 (ex: 525395809)' }
    ]
  },
  'marketing-ia': {
    key: 'marketing-ia',
    name: 'IA Estrategista',
    description: 'Analise inteligente com Claude (Anthropic) ou GPT-4',
    section: 'ai',
    color: '#D97706',
    icon: (
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="#D97706">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
      </svg>
    ),
    fields: [
      { key: 'provider', label: 'Provider', type: 'select', required: true, help: 'Selecione o provedor de IA', options: [{ value: 'anthropic', label: 'Anthropic (Claude)' }, { value: 'openai', label: 'OpenAI (GPT-4)' }] },
      { key: 'model', label: 'Modelo', type: 'text', required: true, help: 'Nome do modelo (ex: claude-sonnet-4-20250514 ou gpt-4-turbo-preview)' },
      { key: 'api_key', label: 'API Key', type: 'password', required: true, help: 'Chave de API do provedor selecionado' }
    ]
  }
}

const SECTIONS = [
  { key: 'communication', title: 'Canais de Comunicacao', gradient: 'from-purple-600 to-indigo-600', integrations: ['brevo', 'zapi'] },
  { key: 'ads', title: 'Anuncios', gradient: 'from-blue-600 to-cyan-600', integrations: ['meta-ads', 'google-ads'] },
  { key: 'analytics', title: 'Analytics', gradient: 'from-orange-500 to-amber-500', integrations: ['ga4', 'ga4-data'] },
  { key: 'seo', title: 'SEO & Busca', gradient: 'from-red-500 to-rose-500', integrations: ['search-console'] },
  { key: 'presence', title: 'Presenca Digital', gradient: 'from-emerald-600 to-teal-600', integrations: ['google-my-business'] },
  { key: 'ai', title: 'Inteligencia Artificial', gradient: 'from-amber-500 to-yellow-500', integrations: ['marketing-ia'] }
]

// ---------------------------------------------------------------------------
// Section icon map
// ---------------------------------------------------------------------------
const SECTION_ICONS = {
  communication: (
    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
    </svg>
  ),
  ads: (
    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
    </svg>
  ),
  analytics: (
    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  ),
  presence: (
    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  seo: (
    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
  ai: (
    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Helper: mask a string leaving only the last 4 chars visible
// ---------------------------------------------------------------------------
function maskValue(value) {
  if (!value) return ''
  if (value.length <= 8) return '*'.repeat(value.length)
  return '*'.repeat(value.length - 4) + value.slice(-4)
}

// ---------------------------------------------------------------------------
// Helper: format date
// ---------------------------------------------------------------------------
function formatTimestamp(ts) {
  if (!ts) return null
  try {
    const d = new Date(ts)
    if (isNaN(d.getTime())) return null
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  } catch {
    return null
  }
}

// ---------------------------------------------------------------------------
// Helper: relative time (e.g., "2 horas atras")
// ---------------------------------------------------------------------------
function relativeTime(ts) {
  if (!ts) return ''
  try {
    const now = Date.now()
    const then = new Date(ts).getTime()
    if (isNaN(then)) return ''
    const diffMs = now - then
    const diffMin = Math.floor(diffMs / 60000)
    if (diffMin < 1) return 'agora mesmo'
    if (diffMin < 60) return `${diffMin} min atras`
    const diffHr = Math.floor(diffMin / 60)
    if (diffHr < 24) return `${diffHr}h atras`
    const diffDays = Math.floor(diffHr / 24)
    if (diffDays < 30) return `${diffDays}d atras`
    return formatTimestamp(ts) || ''
  } catch {
    return ''
  }
}

// ---------------------------------------------------------------------------
// Helper: count section stats
// ---------------------------------------------------------------------------
function getSectionStats(sectionIntegrations, statuses) {
  let active = 0
  let configured = 0
  const total = sectionIntegrations.length
  for (const key of sectionIntegrations) {
    const s = statuses[key]
    if (s?.configured) {
      configured++
      if (s?.enabled) active++
    }
  }
  return { active, configured, total }
}

// ---------------------------------------------------------------------------
// Sub-component: Toggle Switch
// ---------------------------------------------------------------------------
function ToggleSwitch({ enabled, onChange, disabled }) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onChange(!enabled)}
      className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${enabled ? 'bg-purple-600' : 'bg-gray-300 dark:bg-gray-600'}`}
    >
      <span
        className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
          enabled ? 'translate-x-5' : 'translate-x-0'
        }`}
      />
    </button>
  )
}

// ---------------------------------------------------------------------------
// Sub-component: Password Field with show/hide
// ---------------------------------------------------------------------------
function SecureField({ value, onChange, placeholder, help, disabled }) {
  const [visible, setVisible] = useState(false)

  return (
    <div className="relative">
      <input
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full px-3 py-2 pr-10 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:ring-2 focus:ring-purple-500 focus:border-transparent transition disabled:opacity-50 disabled:cursor-not-allowed text-sm"
      />
      <button
        type="button"
        onClick={() => setVisible(!visible)}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        tabIndex={-1}
      >
        {visible ? (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
          </svg>
        ) : (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        )}
      </button>
      {help && <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">{help}</p>}
    </div>
  )
}

// ---------------------------------------------------------------------------
// Sub-component: Status Dot
// ---------------------------------------------------------------------------
function StatusDot({ status }) {
  const config = {
    connected: { color: 'bg-green-500', pulse: true, label: 'Conectado' },
    configured: { color: 'bg-yellow-500', pulse: false, label: 'Configurado (desativado)' },
    disconnected: { color: 'bg-gray-400 dark:bg-gray-500', pulse: false, label: 'Nao configurado' }
  }
  const c = config[status] || config.disconnected

  return (
    <div className="flex items-center gap-2">
      <span className="relative flex h-3 w-3">
        {c.pulse && <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${c.color} opacity-75`} />}
        <span className={`relative inline-flex rounded-full h-3 w-3 ${c.color}`} />
      </span>
      <span className="text-xs text-gray-500 dark:text-gray-400">{c.label}</span>
    </div>
  )
}

// ---------------------------------------------------------------------------
// Sub-component: Spinner
// ---------------------------------------------------------------------------
function Spinner({ size = 'md' }) {
  const sizes = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-10 h-10' }
  return (
    <svg className={`animate-spin ${sizes[size]} text-purple-500`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Sub-component: Confirm Dialog
// ---------------------------------------------------------------------------
function ConfirmDialog({ title, message, confirmLabel, cancelLabel, onConfirm, onCancel, danger }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onCancel()
    }
    window.addEventListener('keydown', handleEsc)
    return () => window.removeEventListener('keydown', handleEsc)
  }, [onCancel])

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative w-full max-w-sm bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{title}</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">{message}</p>
        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition"
          >
            {cancelLabel || 'Cancelar'}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition ${
              danger
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-purple-600 hover:bg-purple-700'
            }`}
          >
            {confirmLabel || 'Confirmar'}
          </button>
        </div>
      </div>
    </div>
  )
}

// ---------------------------------------------------------------------------
// Sub-component: Config Modal
// ---------------------------------------------------------------------------
function ConfigModal({ integrationKey, currentConfig, onClose, onSave, onDelete }) {
  const definition = INTEGRATIONS_CONFIG[integrationKey]
  const [formData, setFormData] = useState({})
  const [saving, setSaving] = useState(false)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const hasExistingConfig = currentConfig && Object.values(currentConfig).some((v) => v && String(v).trim() !== '')

  useEffect(() => {
    if (definition) {
      const initial = {}
      definition.fields.forEach((f) => {
        initial[f.key] = currentConfig?.[f.key] || ''
      })
      setFormData(initial)
    }
  }, [integrationKey, currentConfig, definition])

  // Escape key closes modal
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && !showDeleteConfirm) onClose()
    }
    window.addEventListener('keydown', handleEsc)
    return () => window.removeEventListener('keydown', handleEsc)
  }, [onClose, showDeleteConfirm])

  if (!definition) return null

  const handleFieldChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Validate required fields
    for (const field of definition.fields) {
      if (field.required && !formData[field.key]?.trim()) {
        toast.error(`O campo "${field.label}" e obrigatorio`)
        return
      }
    }

    setSaving(true)
    try {
      await onSave(integrationKey, formData)
    } finally {
      setSaving(false)
    }
  }

  const handleClearConfig = async () => {
    setDeleting(true)
    try {
      // Send empty object to clear all fields
      const emptyData = {}
      definition.fields.forEach((f) => {
        emptyData[f.key] = ''
      })
      await onSave(integrationKey, emptyData)
      toast.success('Configuracao removida com sucesso')
    } catch {
      toast.error('Erro ao remover configuracao')
    } finally {
      setDeleting(false)
      setShowDeleteConfirm(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative w-full max-w-lg bg-white dark:bg-gray-800 rounded-2xl shadow-2xl overflow-hidden">
        {/* Color accent */}
        <div className="h-1.5" style={{ backgroundColor: definition.color }} />

        {/* Header */}
        <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <div className="flex-shrink-0 p-1.5 bg-gray-50 dark:bg-gray-700/50 rounded-lg">{definition.icon}</div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Configurar {definition.name}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">{definition.description}</p>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition"
            title="Fechar (Esc)"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit}>
          <div className="px-6 py-4 space-y-4 max-h-[60vh] overflow-y-auto">
            {definition.fields.map((field) => (
              <div key={field.key}>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  {field.label}
                  {field.required && <span className="text-red-500 ml-1">*</span>}
                  {!field.required && <span className="text-gray-400 dark:text-gray-500 ml-1 text-xs">(opcional)</span>}
                </label>
                {field.type === 'password' ? (
                  <SecureField
                    value={formData[field.key] || ''}
                    onChange={(val) => handleFieldChange(field.key, val)}
                    placeholder={`Insira ${field.label.toLowerCase()}`}
                    help={field.help}
                  />
                ) : field.type === 'select' ? (
                  <div>
                    <select
                      value={formData[field.key] || ''}
                      onChange={(e) => handleFieldChange(field.key, e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-purple-500 focus:border-transparent transition text-sm"
                    >
                      <option value="">Selecione...</option>
                      {field.options?.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                    {field.help && <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">{field.help}</p>}
                  </div>
                ) : (
                  <div>
                    <input
                      type="text"
                      value={formData[field.key] || ''}
                      onChange={(e) => handleFieldChange(field.key, e.target.value)}
                      placeholder={`Insira ${field.label.toLowerCase()}`}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:ring-2 focus:ring-purple-500 focus:border-transparent transition text-sm"
                    />
                    {field.help && <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">{field.help}</p>}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
            {/* Left side: delete button */}
            <div>
              {hasExistingConfig && (
                <button
                  type="button"
                  onClick={() => setShowDeleteConfirm(true)}
                  disabled={saving || deleting}
                  className="px-3 py-1.5 text-xs font-medium text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition disabled:opacity-50"
                >
                  Limpar Configuracao
                </button>
              )}
            </div>

            {/* Right side: cancel + save */}
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={onClose}
                disabled={saving}
                className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition disabled:opacity-50"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={saving}
                className="px-4 py-2 text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 rounded-lg transition flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {saving && <Spinner size="sm" />}
                {saving ? 'Salvando...' : 'Salvar Configuracao'}
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* Delete confirmation */}
      {showDeleteConfirm && (
        <ConfirmDialog
          title="Limpar configuracao"
          message={`Deseja remover todas as credenciais de ${definition.name}? A integracao sera desativada automaticamente.`}
          confirmLabel={deleting ? 'Removendo...' : 'Sim, limpar'}
          cancelLabel="Nao, manter"
          danger
          onConfirm={handleClearConfig}
          onCancel={() => setShowDeleteConfirm(false)}
        />
      )}
    </div>
  )
}

// ---------------------------------------------------------------------------
// Sub-component: Integration Card
// ---------------------------------------------------------------------------
function IntegrationCard({ integrationKey, statusData, onConfigure, onTest, onToggle, testingKey }) {
  const definition = INTEGRATIONS_CONFIG[integrationKey]
  if (!definition) return null

  const isConfigured = statusData?.configured || false
  const isEnabled = statusData?.enabled || false
  const lastUpdated = statusData?.updated_at || statusData?.last_updated || null
  const lastTested = statusData?.last_tested || null
  const testResult = statusData?.test_result || null
  const isTesting = testingKey === integrationKey

  let statusValue = 'disconnected'
  if (isConfigured && isEnabled) statusValue = 'connected'
  else if (isConfigured && !isEnabled) statusValue = 'configured'

  const relTime = relativeTime(lastUpdated)

  return (
    <div className="group relative bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden hover:shadow-lg hover:border-purple-300 dark:hover:border-purple-600 transition-all duration-200">
      {/* Color accent bar */}
      <div className="h-1" style={{ backgroundColor: definition.color }} />

      <div className="p-4">
        {/* Top row: Icon, name, toggle */}
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0 p-2 bg-gray-50 dark:bg-gray-700/50 rounded-lg group-hover:scale-105 transition-transform">
              {definition.icon}
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white text-sm">{definition.name}</h4>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 line-clamp-1">{definition.description}</p>
            </div>
          </div>
          <div className="flex flex-col items-end gap-1">
            <ToggleSwitch
              enabled={isEnabled}
              disabled={!isConfigured}
              onChange={(val) => onToggle(integrationKey, val)}
            />
            {!isConfigured && (
              <span className="text-[10px] text-gray-400 dark:text-gray-500">Configure para ativar</span>
            )}
          </div>
        </div>

        {/* Status row */}
        <div className="flex items-center justify-between mb-2">
          <StatusDot status={statusValue} />
          {lastTested && testResult === 'success' && (
            <span className="inline-flex items-center gap-1 text-[10px] text-green-600 dark:text-green-400">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Teste OK
            </span>
          )}
          {lastTested && testResult === 'failed' && (
            <span className="inline-flex items-center gap-1 text-[10px] text-red-600 dark:text-red-400">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Teste falhou
            </span>
          )}
        </div>

        {/* Timestamp */}
        {lastUpdated && (
          <div className="mb-3">
            <span
              className="text-[10px] text-gray-400 dark:text-gray-500"
              title={formatTimestamp(lastUpdated) || ''}
            >
              Atualizado {relTime}
            </span>
          </div>
        )}

        {/* Configured fields preview (masked) */}
        {isConfigured && definition.fields.length > 0 && (
          <div className="mb-3 flex flex-wrap gap-1">
            {definition.fields
              .filter((f) => f.required)
              .slice(0, 3)
              .map((f) => (
                <span
                  key={f.key}
                  className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] bg-gray-100 dark:bg-gray-700/60 text-gray-500 dark:text-gray-400 font-mono"
                  title={f.label}
                >
                  {f.label.split(' ')[0]}
                  <svg className="w-2.5 h-2.5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </span>
              ))}
          </div>
        )}

        {/* Action buttons */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => onConfigure(integrationKey)}
            className="flex-1 px-3 py-1.5 text-xs font-medium text-purple-700 dark:text-purple-300 bg-purple-50 dark:bg-purple-900/30 border border-purple-200 dark:border-purple-700 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-900/50 transition"
          >
            <span className="flex items-center justify-center gap-1">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              Configurar
            </span>
          </button>

          {isConfigured && (
            <button
              onClick={() => onTest(integrationKey)}
              disabled={isTesting}
              className="flex-1 px-3 py-1.5 text-xs font-medium text-emerald-700 dark:text-emerald-300 bg-emerald-50 dark:bg-emerald-900/30 border border-emerald-200 dark:border-emerald-700 rounded-lg hover:bg-emerald-100 dark:hover:bg-emerald-900/50 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span className="flex items-center justify-center gap-1">
                {isTesting ? (
                  <Spinner size="sm" />
                ) : (
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                )}
                {isTesting ? 'Testando...' : 'Testar Conexao'}
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

// ---------------------------------------------------------------------------
// Main Page Component
// ---------------------------------------------------------------------------
const MarketingIntegrationsPage = () => {
  const [statuses, setStatuses] = useState({})
  const [loading, setLoading] = useState(true)
  const [configModal, setConfigModal] = useState(null) // integration key or null
  const [configData, setConfigData] = useState(null)
  const [loadingConfig, setLoadingConfig] = useState(false)
  const [testingKey, setTestingKey] = useState(null)

  // ------- Load all statuses -------
  const loadStatuses = useCallback(async () => {
    try {
      const response = await api.get('/api/marketing/integrations/status')
      const data = response.data?.integrations || response.data || {}
      setStatuses(data)
    } catch (error) {
      console.error('Erro ao carregar status das integracoes:', error)
      toast.error('Erro ao carregar status das integracoes')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadStatuses()
  }, [loadStatuses])

  // ------- Open configure modal -------
  const handleConfigure = useCallback(async (integrationKey) => {
    setConfigModal(integrationKey)
    setConfigData(null)
    setLoadingConfig(true)

    try {
      // For brevo and zapi we just show their status endpoint
      let endpoint
      if (integrationKey === 'brevo') {
        endpoint = '/api/marketing/integrations/brevo/status'
      } else if (integrationKey === 'zapi') {
        endpoint = '/api/marketing/integrations/zapi/status'
      } else {
        endpoint = `/api/marketing/integrations/${integrationKey}/config`
      }

      const response = await api.get(endpoint)
      setConfigData(response.data?.config || response.data || {})
    } catch (error) {
      // If 404, treat as empty config
      if (error.response?.status !== 404) {
        console.error('Erro ao carregar configuracao:', error)
        toast.error('Erro ao carregar configuracao')
      }
      setConfigData({})
    } finally {
      setLoadingConfig(false)
    }
  }, [])

  // ------- Save config -------
  const handleSaveConfig = useCallback(async (integrationKey, data) => {
    try {
      await api.put(`/api/marketing/integrations/${integrationKey}/config`, data)
      toast.success('Configuracao salva com sucesso!')
      setConfigModal(null)
      setConfigData(null)
      await loadStatuses()
    } catch (error) {
      console.error('Erro ao salvar configuracao:', error)
      const message = error.response?.data?.error || error.response?.data?.message || 'Erro ao salvar configuracao'
      toast.error(message)
    }
  }, [loadStatuses])

  // ------- Test connection -------
  const handleTestConnection = useCallback(async (integrationKey) => {
    setTestingKey(integrationKey)
    try {
      const response = await api.post(`/api/marketing/integrations/${integrationKey}/test`)
      const success = response.data?.success || response.data?.connected

      if (success) {
        toast.success(`${INTEGRATIONS_CONFIG[integrationKey]?.name}: conexao bem-sucedida!`)
      } else {
        const msg = response.data?.error || response.data?.message || 'Teste falhou'
        toast.error(`${INTEGRATIONS_CONFIG[integrationKey]?.name}: ${msg}`)
      }
      await loadStatuses()
    } catch (error) {
      console.error('Erro ao testar conexao:', error)
      const message = error.response?.data?.error || error.response?.data?.message || 'Erro ao testar conexao'
      toast.error(`${INTEGRATIONS_CONFIG[integrationKey]?.name}: ${message}`)
    } finally {
      setTestingKey(null)
    }
  }, [loadStatuses])

  // ------- Toggle enabled/disabled -------
  const handleToggle = useCallback(async (integrationKey, enabled) => {
    try {
      await api.put(`/api/marketing/integrations/${integrationKey}/toggle`, { enabled })
      toast.success(enabled ? 'Integracao ativada' : 'Integracao desativada')
      await loadStatuses()
    } catch (error) {
      console.error('Erro ao alternar integracao:', error)
      const message = error.response?.data?.error || error.response?.data?.message || 'Erro ao alternar integracao'
      toast.error(message)
    }
  }, [loadStatuses])

  // ------- Close modal -------
  const handleCloseModal = useCallback(() => {
    setConfigModal(null)
    setConfigData(null)
  }, [])

  // ------- Count statuses for summary -------
  const countConnected = Object.values(statuses).filter((s) => s?.configured && s?.enabled).length
  const countConfigured = Object.values(statuses).filter((s) => s?.configured).length
  const totalIntegrations = Object.keys(INTEGRATIONS_CONFIG).length

  // ------- Render -------
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <Spinner size="lg" />
          <p className="mt-4 text-gray-500 dark:text-gray-400">Carregando integracoes...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Page Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Integracoes de Marketing
              </h1>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                Gerencie as integracoes com plataformas de marketing, anuncios e analytics
              </p>
            </div>

            {/* Summary badges + refresh */}
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border border-green-200 dark:border-green-700">
                <span className="w-2 h-2 rounded-full bg-green-500" />
                {countConnected} ativa{countConnected !== 1 ? 's' : ''}
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 border border-blue-200 dark:border-blue-700">
                <span className="w-2 h-2 rounded-full bg-blue-500" />
                {countConfigured}/{totalIntegrations} configurada{countConfigured !== 1 ? 's' : ''}
              </span>
              <button
                onClick={() => { setLoading(true); loadStatuses() }}
                className="p-2 rounded-lg text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
                title="Atualizar status"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-8">
          {SECTIONS.map((section) => (
            <div key={section.key}>
              {/* Section Header */}
              {(() => {
                const stats = getSectionStats(section.integrations, statuses)
                return (
                  <div className={`mb-4 rounded-lg bg-gradient-to-r ${section.gradient} px-5 py-3 flex items-center justify-between`}>
                    <div className="flex items-center gap-2.5">
                      {SECTION_ICONS[section.key]}
                      <h2 className="text-base font-semibold text-white tracking-wide">{section.title}</h2>
                    </div>
                    <div className="flex items-center gap-2">
                      {stats.active > 0 && (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium bg-white/20 text-white">
                          <span className="w-1.5 h-1.5 rounded-full bg-green-300" />
                          {stats.active} ativa{stats.active !== 1 ? 's' : ''}
                        </span>
                      )}
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-white/20 text-white">
                        {stats.configured}/{stats.total}
                      </span>
                    </div>
                  </div>
                )
              })()}

              {/* Cards Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                {section.integrations.map((intKey) => (
                  <IntegrationCard
                    key={intKey}
                    integrationKey={intKey}
                    statusData={statuses[intKey] || {}}
                    onConfigure={handleConfigure}
                    onTest={handleTestConnection}
                    onToggle={handleToggle}
                    testingKey={testingKey}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Help Footer */}
        <div className="mt-10 p-5 bg-gray-100 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700 rounded-xl">
          <div className="flex items-start gap-3 mb-4">
            <svg className="w-5 h-5 text-gray-400 dark:text-gray-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300">Como configurar as integracoes</h4>
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
                Configure cada integracao com suas credenciais de API. Apos salvar, use o botao "Testar Conexao" para
                verificar se as credenciais estao corretas. Use o toggle para ativar ou desativar cada integracao
                sem perder as configuracoes salvas.
              </p>
            </div>
          </div>

          {/* Quick reference links */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-3">
            <div className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-gray-700/40 rounded-lg">
              <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#0B996E' }} />
              <span className="text-xs text-gray-600 dark:text-gray-400">
                <span className="font-medium text-gray-700 dark:text-gray-300">Brevo:</span> app.brevo.com &gt; Configuracoes &gt; API Keys
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-gray-700/40 rounded-lg">
              <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#25D366' }} />
              <span className="text-xs text-gray-600 dark:text-gray-400">
                <span className="font-medium text-gray-700 dark:text-gray-300">Z-API:</span> painel z-api.io &gt; Instancias
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-gray-700/40 rounded-lg">
              <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#1877F2' }} />
              <span className="text-xs text-gray-600 dark:text-gray-400">
                <span className="font-medium text-gray-700 dark:text-gray-300">Meta Ads:</span> developers.facebook.com &gt; Marketing API
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-gray-700/40 rounded-lg">
              <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4285F4' }} />
              <span className="text-xs text-gray-600 dark:text-gray-400">
                <span className="font-medium text-gray-700 dark:text-gray-300">Google Ads:</span> ads.google.com/aw/apicenter
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-gray-700/40 rounded-lg">
              <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#E37400' }} />
              <span className="text-xs text-gray-600 dark:text-gray-400">
                <span className="font-medium text-gray-700 dark:text-gray-300">GA4:</span> analytics.google.com &gt; Admin &gt; Data Streams
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-gray-700/40 rounded-lg">
              <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4285F4' }} />
              <span className="text-xs text-gray-600 dark:text-gray-400">
                <span className="font-medium text-gray-700 dark:text-gray-300">GMB:</span> business.google.com &gt; Configuracoes
              </span>
            </div>
          </div>

          <p className="mt-3 text-[10px] text-gray-400 dark:text-gray-500 text-center">
            As credenciais sao armazenadas de forma segura no servidor. Tokens e secrets nunca sao exibidos em texto puro apos salvar.
          </p>
        </div>
      </div>

      {/* Config Modal */}
      {configModal && (
        loadingConfig ? (
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={handleCloseModal} />
            <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8">
              <Spinner size="lg" />
              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">Carregando configuracao...</p>
            </div>
          </div>
        ) : (
          <ConfigModal
            integrationKey={configModal}
            currentConfig={configData}
            onClose={handleCloseModal}
            onSave={handleSaveConfig}
          />
        )
      )}
    </div>
  )
}

export default MarketingIntegrationsPage
